import React from 'react';
import { ConnectionVariableModel } from '@mm/state/model/ConnectionVariableModel';
import AttributeModel from '@mm/state/model/AttributeModel';
import { VariableRow } from './VariableRow/VariableRow';
import { filteredAttirbutes } from '@mm/state/helpers/connection-helpers';
import './VariablesList.pcss';

type Props = {
  variables: ConnectionVariableModel[];
  attributes: AttributeModel[];
  onVariableDelete: (index: number) => void;
  onVariableUpdate: (
    index: number,
    nextVariable: ConnectionVariableModel,
  ) => void;
  customOptionsPosition?: 'top' | 'bottom';
};

export const VariablesList = ({
  variables,
  attributes,
  onVariableDelete,
  onVariableUpdate,
  customOptionsPosition,
}: Props) => {
  return (
    <div>
      <div className="connection-variables-list__title-section">
        <div className="edit-connection-panel__title connection-variables-list__name-label">
          JSON Path
        </div>
        <div className="edit-connection-panel__title connection-variables-list__value-label">
          Attribute Name
        </div>
      </div>
      <div>
        {variables.map((v, index) => (
          <VariableRow
            key={v.id}
            variable={v}
            options={filteredAttirbutes(attributes, variables)}
            onDelete={() => onVariableDelete(index)}
            onUpdate={nextVariable => onVariableUpdate(index, nextVariable)}
            selectedAttribute={attributes.find(attr => attr.name === v.name)}
            customOptionsPosition={customOptionsPosition}
          />
        ))}
      </div>
    </div>
  );
};
